import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import BASEURL from '../API/Config';

const PurchaseReport = () => {
  const [purchases, setPurchases] = useState([]);
  const [filteredPurchases, setFilteredPurchases] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const token = localStorage.getItem('token');

  // Fetch purchases when the component is mounted
  useEffect(() => {
    const fetchPurchases = async () => {
      try {
        const response = await fetch(`${BASEURL}/purchases/list`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error('Failed to fetch purchase data.');

        const data = await response.json();
        setPurchases(data);
        setFilteredPurchases(data);

        if (data.length === 0) {
          Swal.fire({
            icon: 'info',
            title: 'No Purchase Data',
            text: 'There are no purchase items available at the moment.',
          });
        }
      } catch (error) {
        console.error(error);
        // Swal.fire({
        //   icon: 'error',
        //   title: 'Error',
        //   text: 'Failed to load purchase data.',
        // });
      }
    };

    fetchPurchases();
  }, [token]);

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    // Filter purchases based on search query (by item name)
    const filtered = purchases.filter((purchase) =>
      purchase.itemName.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredPurchases(filtered);

    if (filtered.length === 0) {
      Swal.fire({
        icon: 'info',
        title: 'No Results Found',
        text: 'No purchases match your search query.',
      });
    }
  };

  // Export filtered purchases to Excel
  const handleExportExcel = () => {
    const data = filteredPurchases.map((purchase) => ({
      'Purchase ID': purchase.id,
      'Item Name': purchase.itemName,
      Category: purchase.category,
      'Purchase Quantity': purchase.quantity,
      'Price per Unit': purchase.pricePerUnit.toFixed(2),
      'Purchase Date': purchase.purchaseDate,
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Purchases Report');

    // Export the data to an Excel file
    XLSX.writeFile(wb, 'Purchases_Report.xlsx');
  };

  return (
    <div>
      <h4 className="text-center">Purchases Report</h4>

      {/* Search Bar */}
      <input
        type="text"
        className="form-control mb-4"
        placeholder="Search by item name"
        value={searchQuery}
        onChange={handleSearch}
      />

      {/* Export Excel Button */}
      <div className="d-flex justify-content-end mb-4">
        <button className="btn btn-success" onClick={handleExportExcel}>
          Export to Excel
        </button>
      </div>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Purchase ID</th>
            <th>Item Name</th>
            <th>Category</th>
            <th>Purchase Quantity</th>
            <th>Price per Unit</th>
            <th>Purchase Date</th>
          </tr>
        </thead>
        <tbody>
          {filteredPurchases.length > 0 ? (
            filteredPurchases.map((purchase) => (
              <tr key={purchase.id}>
                <td>{purchase.id}</td>
                <td>{purchase.itemName}</td>
                <td>{purchase.category}</td>
                <td>{purchase.quantity}</td>
                <td>{purchase.pricePerUnit.toFixed(2)}</td>
                <td>{purchase.purchaseDate}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center">
                No purchase data available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PurchaseReport;
